<template>
    <button
        type="button"
        role="button"
        @click="handleClick"
        class="a-guide-overview-button guide-overview-button d-path-steps__button"
        :aria-label="ariaLabel"
        :class="{'guide-overview-button--active': active}"
    >
        <span
            v-if="iconPath"
            class="a-guide-overview-button__icons-wrapper"
        >
            <svg-icon
                original
                name="icons/guide-path"
                class="a-guide-overview-button__path"
            />
        </span>
        <span class="guide-overview-button__text">
            {{ $t('a-guide-overview-button') }}
        </span>
        <span
            v-if="isDistanceShow"
            class="guide-overview-button__distance"
        >
            {{distance}} {{$t('ui.meter')}}
        </span>
        <svg-icon
            original
            name="icons/arrow-right-dark"
            class="guide-overview-button__arrow"
        />
    </button>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'AGuideOverviewButton',
    props: {
        active: {
            type: Boolean,
            default: false
        },
        ariaLabel: {
            type: String,
            default: 'Guide overview button'
        },
        iconPath : {
            type: Boolean,
            default: false
        },
        isDistanceShow: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapState({
            distance: state => state.activePath?.distance
        })
    },
    methods: {
        handleClick() {
            this.$emit('onClick', true);
        }
    }
}
</script>

<style lang="scss">
@import "a-guide-overview-button";
</style>
